import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export type FetchExistingSystemsAction = Request.RequestAction
export type FetchExistingSystems = (communityIdentifier: string) => FetchExistingSystemsAction
export const fetchExistingSystems: FetchExistingSystems = (communityIdentifier: string) =>
  Request.integrationsRequestActionCreator(Constants.FETCH_EXISTING_SYSTEMS)
  ({
    method: 'GET',
    url: `/${communityIdentifier}/existing-systems`,
  })

export type FetchAvailableSystemsAction = Request.RequestAction
export type FetchAvailableSystems = (communityIdentifier: string) => FetchAvailableSystemsAction
export const fetchAvailableSystems: FetchExistingSystems = (communityIdentifier: string) =>
Request.integrationsRequestActionCreator(Constants.FETCH_AVAILABLE_SYSTEMS)
({
  method: 'GET',
  url: `/${communityIdentifier}/available-systems`,
})

export type CreateorUpdateSystemActionCreator = (state: ApplicationState) => Redux.Action
export const createOrUpdateSystem: CreateorUpdateSystemActionCreator = (appState) =>
  !appState.integrations.form.fields.id ? createSystem(appState) : updateSystem(appState)

const createSystem = (appState: ApplicationState) =>
  Request.integrationsRequestActionCreator(Constants.ADD_SYSTEM)({
    method: 'POST',
    payload: appState.integrations.form.fields,
    url: `/${appState.app.selectedCommunity}/community-systems`,
  })

const updateSystem = (appState: ApplicationState) =>
  Request.integrationsRequestActionCreator(Constants.UPDATE_SYSTEM)({
    method: 'PUT',
    payload: appState.integrations.form.fields,
    url: `/${appState.app.selectedCommunity}/community-systems/${appState.integrations.form.fields.id}`,
  })

export const statusUpdate = (communityIdentifier: string, stateChange: IsActive.StateChange) =>
  Request.integrationsRequestActionCreator(Constants.UPDATE_SYSTEM)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `/${communityIdentifier}/community-systems/${stateChange.id}`,
})

export const toggleAddSystemMenu = () => ({ type: Constants.TOGGLE_ADD_SYSTEM_MENU })

export const [FormActions, FormConstants] = Form.createMaps(Constants.SYSTEM_CREDENTIALS_FORM)

export type OpenModalAction = (systemId: number, name: string, syncType: string, targetObject: string) =>
Form.EnterAction<Types.FormFields>
export const onOpen: OpenModalAction = (systemId, name, syncType, targetObject) =>
FormActions[Form.ENTER]({
  ...Constants.emptyFormField,
  sync_type: syncType,
  system_id: systemId,
  system_name: name,
  target_object: targetObject,
  // TODO: to be fixed later
})

export type ResetModal = Modal.Reset
export const resetModal: ResetModal = Modal.resetModal(Constants.ADD_SYSTEM)
export type ToggleModal = Modal.Toggle
export const closeModal: ToggleModal = Modal.closeModal(Constants.ADD_SYSTEM)

type EditModalAction = (system: Types.System, editType: string) => Form.EnterAction<Types.FormFields>
export const onEdit: EditModalAction = (system: Types.System, editType: string) => FormActions[Form.ENTER](
  Utils.asFormFields(system),
)



// WEBPACK FOOTER //
// ./src/pages/integrations/actions.ts